import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    colors: {
      main: '#1e1e1e',
      background: '#141414',
      header: '#040404'
    }
  },
  })
// import { theme } from '../theme'
// const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//     colors: {
//       main: '#1e1e1e',
//       background: '#141414',
//       header: '#040404'
//     }
//   },
// });

// const lightTheme = createTheme({
//   palette: {
//     mode: 'light',
//     primary: {
//       main: "#4C9A2A"
//     },
//     colors: {
//       main: '#4C9A2A',
//       background: 'white',
//       header: 'white',
//       background_gray: '#f5f5f7',
//       map_light_gray: '#f3f3f3',
//       map_text_black: "#757575",
//       delete1: '#e74b30'
//     }
//   },
// });